import { logUsage } from 'owa-analytics';
import { getBposNavBarData } from 'owa-bpos-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { trace } from 'owa-trace';

import { isLinkPrefixedWithBaseUrl } from './isLinkPrefixedWithBaseUrl';

const SHAREPOINT_BASE_URLS = [
    'https://microsoft.sharepoint.com',
    'https://microsoft-my.sharepoint.com',
    'https://microsoft.sharepoint-df.com',
    'https://microsoft-my.sharepoint-df.com',
];

export default function isSharePointLink(linkUrl: string): boolean {
    if (!linkUrl) {
        logUsage('isSharePointLinkCalledWithoutUrl');
        return false;
    }

    const bposNavBarData = getBposNavBarData();
    if (!bposNavBarData) {
        trace.info('isSharePointLink:bposNavBarData is null');
        return false;
    }

    if (
        bposNavBarData.SPO_MySiteHostUrl &&
        isLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_MySiteHostUrl)
    ) {
        return true;
    }

    if (
        bposNavBarData.SPO_RootSiteUrl &&
        isLinkPrefixedWithBaseUrl(linkUrl, bposNavBarData.SPO_RootSiteUrl)
    ) {
        return true;
    }

    if (isFeatureEnabled('doc-SharePoint-dogfoodUser')) {
        return SHAREPOINT_BASE_URLS.some(url => isLinkPrefixedWithBaseUrl(linkUrl, url));
    }

    return false;
}
